"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class MfaAuthentication extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'mfaAuthentication';
        this._token = initParams.token;
    }
    set token(value) {
        console.error('Do not set objects this way');
    }
    get token() {
        return this._token;
    }
}
exports.default = MfaAuthentication;
//# sourceMappingURL=mfaAuthentication.js.map